import React from "react";

// What the page shows instead of rows: while loading, and when there are none.

export function SkeletonList() {
  return (
    <div className="flex flex-col gap-2">
      {[0, 1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4"
        >
          <div className="animate-pulse space-y-2.5">
            <div className="h-3.5 w-2/3 rounded bg-gray-200 dark:bg-gray-700" />
            <div className="h-3 w-5/6 rounded bg-gray-100 dark:bg-gray-700/60" />
            <div className="h-2.5 w-40 rounded bg-gray-100 dark:bg-gray-700/60" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function LoadingDots({ language, small }) {
  const dot = small ? "w-2 h-2" : "w-3 h-3";
  return (
    <div className="flex flex-col gap-2 items-center text-center">
      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          <div className={`${dot} bg-orange-500 rounded-full animate-bounce`} />
          <div
            className={`${dot} bg-orange-500 rounded-full animate-bounce`}
            style={{ animationDelay: "0.1s" }}
          />
          <div
            className={`${dot} bg-orange-500 rounded-full animate-bounce`}
            style={{ animationDelay: "0.2s" }}
          />
        </div>
        {!small && (
          <span className="text-orange-500 text-base lg:text-lg font-semibold">
            {language === "zh" ? "正在加載數據..." : "Loading data..."}
          </span>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ language, hasFilters, folderName, onBrowse, onNewChat, onClear }) {
  if (hasFilters) {
    return (
      <div className="py-16 flex flex-col items-center text-center gap-3">
        <div className="w-14 h-14 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-1">
          <svg
            className="w-6 h-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-4.35-4.35m1.35-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">
          {language === "zh" ? "沒有符合的結果" : "No matching results"}
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {language === "zh"
            ? "試試調整搜尋或日期篩選。"
            : "Try adjusting your search or date filter."}
        </p>
        <button
          className="mt-1 px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors font-medium text-sm"
          onClick={onClear}
        >
          {language === "zh" ? "清除篩選" : "Clear filters"}
        </button>
      </div>
    );
  }
  if (folderName) {
    return (
      <div className="py-12 text-center">
        <p className="text-gray-700 dark:text-gray-200">
          {language === "zh" ? "這裡目前沒有對話。" : "No conversations here yet."}
        </p>
        <button type="button" onClick={onBrowse} className="mt-3 text-sm text-orange-700 dark:text-orange-300 underline">
          {language === "zh" ? "瀏覽所有對話" : "Browse all conversations"}
        </button>
      </div>
    );
  }
  return (
    <div className="py-16 flex flex-col items-center text-center gap-3">
      <div className="w-16 h-16 rounded-full bg-orange-100 dark:bg-orange-500/15 flex items-center justify-center mb-1">
        <svg
          className="w-7 h-7 text-orange-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.9 9.9 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      </div>
      <div className="text-xl lg:text-2xl text-gray-800 dark:text-white font-semibold">
        {language === "zh" ? "沒有找到對話" : "No conversations found."}
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400">
        {language === "zh"
          ? "開始新聊天以查看您的聊天記錄"
          : "Start a new chat to see your chat here"}
      </p>
      <button
        className="mt-2 text-sm bg-orange-500 text-white rounded-xl px-5 py-2.5 shadow-md transition-all duration-300 hover:-translate-y-px hover:bg-orange-600"
        onClick={onNewChat}
      >
        {language === "zh" ? "新聊天" : "New Chat"}
      </button>
    </div>
  );
}
